var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "91.44mm",
    height: "91.44mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 9144 9144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  .fil0 {fill:#F0F0F0} .fil1 {fill:#011627;fill-rule:nonzero}  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2744492898368"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "fil0",
    points: "0,0 9144,0 9144,9144 0,9144 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M2540 2980l4064 0c47,0 85,38 85,84l0 3016c0,46 -38,84 -85,84l-4064 0c-47,0 -85,-38 -85,-84l0 -3016c0,-46 38,-84 85,-84zm3979 169l-3894 0 0 2846 3894 0 0 -2846z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M2480 3124c-33,-33 -33,-86 0,-119 33,-33 86,-33 120,-1l2032 2032c33,33 33,86 0,119 -33,33 -86,33 -120,1l-2032 -2032z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M6544 3004c34,-32 87,-32 120,1 33,33 33,86 0,119l-2032 2032c-33,32 -87,32 -120,-1 -33,-33 -33,-86 1,-119l2031 -2032z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.fcd56b888d357d80fb7b4b5e0929ae75.svg";
export { ForwardRef as ReactComponent };